import { Box, Flex, Stack } from '@chakra-ui/react';
import FreeServiceTag from '@components/features/FreeServiceTag';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import period from '@public/assets/period.svg';
import Image from 'next/image';
import CTA from '../CTA';

const ImageHero = ({
  header,
  subheader,
  ctaType,
  buttonText,
  imageSrc,
  imageAlt,
  showPeriod = false,
  onSubmit = null,
  href = null,
}) => {
  return (
    <Flex
      px={[0, 0, 16]}
      py={[6, 6, 16]}
      gap={[4, 4, 12]}
      alignItems="center"
      flexDir={['column-reverse', 'column-reverse', 'row']}
    >
      <Stack w={['100%', '100%', '50%']} spacing={6}>
        <Header as="h2">
          {header}
          {showPeriod && (
            <Box display="inline-block" as="span" width={['8px', '12px', '12px', '16px']} ml={[1, 2, 2, 3]}>
              <Image src={period} alt="Stylistic Period" style={{ display: 'inline' }} />
            </Box>
          )}
        </Header>
        <Body1>{subheader}</Body1>
        <CTA ctaType={ctaType} width="450px" buttonText={buttonText} onSubmit={onSubmit} href={href} />
        <Box pt={4}>
          <FreeServiceTag />
        </Box>
      </Stack>
      <Box w={['100%', '100%', '50%']} px={[20, 20, 20]} py={[8, 8, 20]}>
        <Image src={imageSrc} alt={imageAlt} width={600} height={600} />
      </Box>
    </Flex>
  );
};

export default ImageHero;
